/**
 * Production Environment Configuration
 *
 * SECURITY: API keys MUST be loaded from environment variables at build time.
 * Set environment variables in your CI/CD pipeline before building.
 * NEVER commit production API keys to version control.
 *
 * Example CI/CD build command:
 *   export GOOGLE_GEMINI_API_KEY="your-key"
 *   export SENTRY_DSN="your-dsn"
 *   npm run build:prod
 *
 * Note: Firebase API Key is safe to expose (public key with domain restrictions).
 * Sensitive keys (Gemini, Sentry) MUST be loaded from environment variables.
 */

// Helper function to safely read environment variables
const getEnvVar = (key: string, fallback: string = ''): string => {
  if (typeof process !== 'undefined' && process.env && process.env[key]) {
    return process.env[key] as string;
  }
  // In production, throw error if sensitive key is missing
  if (!fallback && (key === 'GOOGLE_GEMINI_API_KEY' || key === 'SENTRY_DSN')) {
    console.error(`SECURITY WARNING: ${key} not set in production!`);
  }
  return fallback;
};

export const environment = {
  production: true,

  firebase: {
    // Firebase API Key is safe to expose (public key with domain restrictions)
    apiKey: getEnvVar('FIREBASE_API_KEY', 'AIzaSyC4TnoZSMGMJAdnbNsxUl-6VPjxdkoYJvo'),
    authDomain: getEnvVar('FIREBASE_AUTH_DOMAIN', 'farturk-reg.firebaseapp.com'),
    projectId: getEnvVar('FIREBASE_PROJECT_ID', 'farturk-reg'),
    storageBucket: getEnvVar('FIREBASE_STORAGE_BUCKET', 'farturk-reg.firebasestorage.app'),
    messagingSenderId: getEnvVar('FIREBASE_MESSAGING_SENDER_ID', '418878379176'),
    appId: getEnvVar('FIREBASE_APP_ID', '1:418878379176:web:daf938582734c28f5b5e9d')
  },

  googleOAuth: {
    // OAuth Client ID is safe to expose (public identifier)
    clientId: getEnvVar('GOOGLE_CLIENT_ID', '418878379176-6dp78ott9b3737asmj44uph28va8nrom.apps.googleusercontent.com'),
    // Client secret should NEVER be exposed in frontend code
    // It's only used for server-side authentication in Cloud Functions
  },

  // Google Gemini AI API Key - CRITICAL: Must be set via environment variable
  // DO NOT hardcode production API keys
  googleApiKey: getEnvVar('GOOGLE_GEMINI_API_KEY', ''),

  // Google Analytics Configuration (Production)
  googleAnalytics: {
    measurementId: getEnvVar('GOOGLE_ANALYTICS_MEASUREMENT_ID', 'G-XXXXXXXXXX'),
    enabled: true, // Enabled in production (requires user consent via CookieConsentService)
    anonymizeIp: true, // IP anonymization for GDPR/KVKK compliance
    cookieFlags: 'SameSite=None;Secure'
  },

  // Sentry Error Tracking - CRITICAL: Must be set via environment variable
  // Configured: 23 Ekim 2025
  // Organization: Cureonics
  // Project: farturk-reg
  // Region: Europe (de.sentry.io)
  sentry: {
    dsn: getEnvVar('SENTRY_DSN', ''),
    enabled: !!getEnvVar('SENTRY_DSN', ''), // Auto-enable if DSN is provided
    environment: 'production',
    tracesSampleRate: parseFloat(getEnvVar('SENTRY_TRACES_SAMPLE_RATE', '0.2')),
    replaysSessionSampleRate: parseFloat(getEnvVar('SENTRY_REPLAYS_SESSION_SAMPLE_RATE', '0.1')),
    replaysOnErrorSampleRate: parseFloat(getEnvVar('SENTRY_REPLAYS_ERROR_SAMPLE_RATE', '1.0'))
  }
};